<template>
  <div class="module" :class="{
		'l-row--t64 l-row--t128l': data.target.size == 1 || data.target.size == 2 || data.target.size == 3,
		'fpic-in': data.target.size == 4,
		'l-full--t64 l-full--t128l': data.target.size == 0 || data.target.size == 4,
		'fpic-out': data.target.size == 0
	}">
		<div :class="{
			's--h-start': data.target.align == 0,
			'g-row': data.target.size != 0 && data.target.size != 4,
			's--h-end': data.target.align == 2,
			'': data.target.size == 3 || data.target.size == 4
		}">
			<div :class="{
				'': data.target.size == 0 || data.target.size == 4,
				'g-col--15 g-col--5s': data.target.size == 1,
				'g-col--13 g-col--5s': data.target.size == 2,
				'g-col--9 g-col--5s': data.target.size == 3,
			}">
				<div class="c-pic">
					<Picture :src="data.target.src" :coverSrc="data.target.coverSrc" :parallax="data.target.parallax == 0 ? false : true" :embedType="data.target.embedType" :ratio="data.target.ratio" />
					<!-- <img class='m-pic' v-if='data.target' :src="data.target.src" alt=""> -->
					<div class="c-pic__desc" :class="{
						'fpic-out__desc': data.target.size == 0,
						'fpic-in__desc': data.target.size == 4
					}">
						<div class="t-h--13 t-h--11s">
							<span class="t--fak c-pic__desc--info" v-html="data.target.caption"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { computed, onMounted, ref, reactive, watch, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";


export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture
	},
  setup(props) {
    const { state, get, commit } = useStore();
		const self = ref();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

    return {
			self,
			data,
    };
  },
};
</script>

<style scoped lang="scss">
.fpic-out {
	&__desc {
		margin-left: 16em;
		margin-right: 16em;
		overflow: hidden;
	}
}
.fpic-in {
	position: relative;
	&__desc {
		position: absolute;
		left: 16em;
		bottom: 13em;
		// bottom: 16em;
		right: 16em;
		z-index: 40;
		.t-b--13 {
			color: white;
		}
		.__w600 & {
			bottom: 14em;
		}
	}
}
</style>